import { ChangeDetectionStrategy, Component, computed, effect, input, output, signal, untracked } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'iot-platform-ui-dropdown',
  imports: [NgTemplateOutlet, MatAutocompleteModule, MatIconModule, MatTooltipModule, TranslatePipe],
  templateUrl: './dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DropdownComponent {
  filter = input<string>('');
  placeholder = input.required<string>();
  options = input<string[]>([]);
  showBlankOptions = input(false);
  disabled = input(false);
  filterChange = output<string>();

  searchTerm = signal<string>('');
  filterChangeEffect = effect(() => {
    const value = this.filter();
    if (untracked(this.searchTerm) !== value) {
      this.searchTerm.set(value);
    }
  });

  filteredOptions = computed(() => {
    const all = this.options();
    const search = this.searchTerm()?.toLowerCase();
    if (!search) return all;
    return all.filter((option) => option.toLowerCase().includes(search));
  });

  onSelect(value: string): void {
    this.filterChange.emit(value);
    this.searchTerm.set(value ?? '');
  }

  onInput(value: string): void {
    this.searchTerm.set(value);
  }

  onClear(): void {
    this.filterChange.emit('');
    this.searchTerm.set('');
  }
}
